import axios from "axios";

import { IP_LOOKUP_ACCESS_TOKEN } from "../constants";

const fetchLocationDetails = () =>
  axios.get(
    "https://neeto-ip-lookup-web-production.neetodeployapp.com/location",
    { headers: { "X-ACCESS-TOKEN": IP_LOOKUP_ACCESS_TOKEN } }
  );

const neetoIpLookupApi = { fetchLocationDetails };
export default neetoIpLookupApi;
